import { FormSection, ControlledInput } from "@excent-one/react/form";
import { FormFieldSet } from "@progress/kendo-react-all";
import { withMemoizedContainer } from "@excent-one/react/utils/children";
import type { IncidentFormSectionProps } from "../types";

interface IncidentHeaderSectionProps extends IncidentFormSectionProps {}

/**
 * The "Header" section: Incident ID/Type/Status/Cycle Age. Pure display of fields already
 * inherited straight from IncidentRecordDto (post Part 2 of the refactor) - no page-level data
 * dependency to own.
 */
const IncidentHeaderSection = withMemoizedContainer(
  FormSection,
  ({ control, loading, ...sectionProps }: IncidentHeaderSectionProps, Container) => (
    <Container loading={loading} {...sectionProps}>
      <FormFieldSet cols={2}>
        <ControlledInput
          name="incidentNumber"
          control={control}
          loading={loading}
          label="Incident ID"
          readOnly
        />
        <ControlledInput
          name="incidentTypeName"
          control={control}
          loading={loading}
          label="Type of Incident"
          readOnly
        />
        <ControlledInput
          name="statusName"
          control={control}
          loading={loading}
          label="Status"
          readOnly
        />
        <ControlledInput
          name="cycleAge"
          control={control}
          loading={loading}
          label="Cycle Age"
          readOnly
        />
      </FormFieldSet>
    </Container>
  ),
);

export default IncidentHeaderSection;
